import { atom } from "jotai";

import { IRegisterWithOwner } from "../models";

/** The signed-in taxpayer's registers, as last written by `useCashRegisters`. */
export const cashRegistersAtom = atom<IRegisterWithOwner[]>([]);
